import {
	type AutoCombineActionDeps,
	editAutoCombineEntryGroupAction,
} from "@/v2/hooks/actions/autoCombine";
import { appendTaskSummary, canAppendTaskSummary } from "../appendTaskSummary";

export function createAppendTaskSummaryAction(
	viewerEmail: string | null | undefined,
	entryId: string,
	sourceId: string,
	deps: AutoCombineActionDeps,
) {
	if (!canAppendTaskSummary(viewerEmail)) return null;
	// Resolve both rows at click time so a moved task or edited narrative cannot
	// be appended using the snapshot that originally rendered the button.
	const entry = deps.getAutoCombine().find((row) => row.id === entryId);
	if (!entry || (entry.status !== "tracked" && entry.status !== "reviewed"))
		return null;
	const source = entry.miniTransactions.find((row) => row.id === sourceId);
	const narrative = appendTaskSummary(entry.description, source?.summary);
	if (narrative === null) return null;
	const action = editAutoCombineEntryGroupAction(entryId, { narrative }, deps);
	return {
		...action,
		toast: {
			success: "Task summary appended to narrative",
			error: "Failed to append task summary",
		},
	};
}
